export default __webpack_public_path__ + "static/media/base.c1924da9.svg";